import { makeBinded } from '@/proxies';

class SysEmployeesEndpointsVO {
  private _baseURL({ origin = env.VITE_AMMINISTRO_API_GATEWAY, v = 'v2' }: { origin?: string; v?: string }) {
    return `${origin}/api/${v}`;
  }

  findOwn({ v }: { v?: string }) {
    return `${this._baseURL({ v })}/employees/sys/own`;
  }
}

const sysEmployeesEndpointsVO = makeBinded(SysEmployeesEndpointsVO);

export { sysEmployeesEndpointsVO };
